import { FC, ReactNode } from 'react';

interface IToolbarProps {
  children?: ReactNode;
  className?: string;
  disableGutters?: boolean;
  variant?: 'regular' | 'dense';
}

export const Toolbar: FC<IToolbarProps> = ({ children, className, disableGutters = false, variant = 'regular' }) => {
  return (
    <div
      className={[
        'relative flex w-full flex-row items-center',
        variant === 'dense' ? 'min-h-12' : 'min-h-16',
        disableGutters ? '' : 'px-4 sm:px-6',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
};
